var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 21.75,
    fill: "#E7E7E7",
    stroke: "#686C73",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2373 21.1748C15.7812 21.1748 15.4116 21.5426 15.4116 21.9965C15.4116 22.4504 15.7812 22.8199 16.2373 22.8199C16.6933 22.8199 17.0629 22.4521 17.0629 21.9965C17.0629 21.541 16.6933 21.1748 16.2373 21.1748Z",
    fill: "#686C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4003 21.0888C23.9087 21.0888 23.5103 21.4853 23.5103 21.9746C23.5103 22.4639 23.9087 22.8604 24.4003 22.8604C24.892 22.8604 25.2904 22.4639 25.2904 21.9746C25.2904 21.4853 24.892 21.0888 24.4003 21.0888Z",
    fill: "#686C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7906 13H14.2111C12.4377 13 11 14.4308 11 16.1957V26.5791C11 28.344 12.4377 29.7748 14.2111 29.7748H20.4196L22.5321 34.727C22.5321 34.727 22.6779 35.1555 23.0288 35.1555C23.3815 35.1555 23.5256 34.727 23.5256 34.727L25.638 29.7748H31.7906C33.564 29.7748 35.0017 28.344 35.0017 26.5791V16.1957C35.0017 14.4308 33.564 13 31.7906 13ZM18.5394 22.1787C18.5292 24.0769 16.5575 24.1309 16.5575 24.1309C15.7946 24.1309 15.3639 23.6281 15.3639 23.6281V23.9706H13.9279V18.0753C13.9279 18.0753 13.9212 18.0736 13.9279 18.0719V18.0753C14.0178 18.0888 15.3639 18.0719 15.3639 18.0719V20.3261C15.7013 19.7525 16.6779 19.7626 16.6779 19.7626C18.8039 19.96 18.5377 22.1787 18.5377 22.1787H18.5394ZM21.0673 19.9448V23.9807H19.6618V19.9853C19.6618 19.442 18.9836 19.2901 18.9836 19.2901V17.8813C21.2283 17.9724 21.0673 19.9448 21.0673 19.9448ZM24.3987 24.1343C23.0966 24.1343 22.0421 23.1675 22.0421 21.9763C22.0421 20.7851 23.0966 19.8183 24.3987 19.8183C25.7008 19.8183 26.7553 20.7851 26.7553 21.9763C26.7553 23.1675 25.7008 24.1343 24.3987 24.1343ZM32.0992 24.1343C32.0992 24.1343 32.1195 26.1843 30.0257 26.1843H29.3882V24.8564H29.7731C29.7731 24.8564 30.653 24.9374 30.6428 23.5876C30.6428 23.5876 30.4716 24.1343 29.2374 24.1343C29.2374 24.1343 27.4877 24.0094 27.4877 22.3104V21.6658C27.4877 21.6658 27.5284 19.9043 29.4493 19.7643C29.4493 19.7643 30.2071 19.6833 30.6734 20.3076V19.8756H32.0992V24.136V24.1343Z",
    fill: "#686C73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8663 21.109C29.3865 21.109 28.9966 21.4971 28.9966 21.9746C28.9966 22.4521 29.3865 22.8402 29.8663 22.8402C30.3461 22.8402 30.7361 22.4521 30.7361 21.9746C30.7361 21.4971 30.3461 21.109 29.8663 21.109Z",
    fill: "#686C73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22.1538,
    fill: "white",
    transform: "translate(11 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.1bd659075309c9a13942fe6bf4d985cd.svg";
export { ForwardRef as ReactComponent };